import {  ErrorObservable  } from '/druid/ErrorObservable';

export const _throw = ErrorObservable.create;